import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  altheaderClass:string;
  constructor(private router: Router) {

    this.router.events.subscribe(event => {
      if(event.constructor.name === "NavigationEnd") {
        // do something...
        console.log(router.url);

        switch(router.url) {
          case "/insan-kaynaklari": {
            this.altheaderClass = "altHeaderIK";
            break;
          }
          case "/hizmetlerimiz": {
            this.altheaderClass = "altHeaderServices";
            break;
          }
          default: {
            this.altheaderClass = "altHeader";
            break;
          }
        }
      }
    });
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/share/slider/slider.component.ts